import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/sunpay/sandbox.png'
import _imports_1 from '@/assets/images/sandbox.png'
import _imports_2 from '@/assets/images/sunpay/icon-sandbox.png'
import _imports_3 from '@/assets/images/icon-sandbox.png'


_pushScopeId("data-v-6ad60836")
const _hoisted_1 = { class: "logo" }
const _hoisted_2 = { class: "img-box" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1
}
const _hoisted_5 = { class: "tag font-bold" }
const _hoisted_6 = { class: "lang" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = {
  key: 0,
  src: _imports_2,
  alt: "sandbox"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_3,
  alt: "sandbox"
}
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "\"ACTION_TYPE\"", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "\"REDIRECT\"", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_popover = _resolveComponent("van-popover")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["klickl-pay-sandbox", { sunpay: _ctx.data.dev == 'sunpaysandbox' || _ctx.data.dev == 'sunpayprod' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.data.dev == 'sunpaysandbox' || _ctx.data.dev == 'sunpayprod')
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : (_openBlock(), _createElementBlock("img", _hoisted_4)),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("example.t001")), 1)
      ]),
      _createVNode(_component_van_popover, {
        show: _ctx.showPopover,
        "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPopover = $event)),
        actions: _ctx.data.langs,
        theme: "dark",
        onSelect: _ctx.changeLang
      }, {
        reference: _withCtx(() => [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.convertLangName), 1)
        ]),
        _: 1
      }, 8, ["show", "actions", "onSelect"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_ctx.data.dev == 'sunpaysandbox' || _ctx.data.dev == 'sunpayprod')
          ? (_openBlock(), _createElementBlock("img", _hoisted_9))
          : (_openBlock(), _createElementBlock("img", _hoisted_10))
      ]),
      _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t("example.t002")), 1),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_i18n_t, {
            keypath: "example.t003",
            scope: "global"
          }, {
            type: _withCtx(() => [
              _hoisted_12
            ]),
            action: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t("example.t006")), 1)
      ])
    ])
  ], 2))
}